import { SettingsFieldSelect } from 'apps/studio/components/settings/inputs/SettingsFieldSelect'
import { SettingsSelect } from 'apps/studio/components/settings/inputs/SettingsSelect'
import { SettingsCheckbox } from 'apps/studio/components/settings/inputs/SettingsCheckbox'
import { SettingsInput } from 'apps/studio/components/settings/inputs/SettingsInput'
import { SettingsTextAreaInput } from 'apps/studio/components/settings/inputs/SettingsTextAreaInput'
import { SettingsRadioButton } from 'apps/studio/components/settings/inputs/SettingsRadioButton'
import { SettingsColorPicker } from 'apps/studio/components/settings/inputs/SettingsColorPicker'
import { SettingsNumberInput } from 'apps/studio/components/settings/inputs/SettingsNumberInput'
import { SettingsToggle } from 'apps/studio/components/settings/inputs/SettingsToggle'
import { SettingsPositionGroup } from 'apps/studio/components/settings/inputs/SettingsPositionGroup'
import { SettingsFontStyleSelect } from 'apps/studio/components/settings/inputs/SettingsFontStyleSelect'
import { SettingsSheetEntrySelect } from 'apps/studio/components/settings/inputs/SettingsSheetEntrySelect'
import {
  SettingsElementStyleSelect,
  SettingsFontFamilySelect,
} from 'apps/studio/components/settings/inputs/SettingsElementStyleSelect'
import { PanelLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'
import { SettingsDynamicParamSelect } from 'apps/studio/components/settings/inputs/SettingsDynamicParamSelect'
import { SettingsTableDimensionInput } from 'apps/studio/components/settings/inputs/SettingsTableDimensionInput'

export const getAdditionalProps = (additionalProps, data = {}) => {
  if (typeof additionalProps === 'function') {
    return additionalProps(data)
  } else if (additionalProps !== null && typeof additionalProps === 'object') {
    return additionalProps
  }
  return {}
}

export const settingInputs = {
  textInput: SettingsInput,
  longTextInput: SettingsTextAreaInput,
  numberInput: SettingsNumberInput,
  selectInput: SettingsSelect,
  elementStyleSelect: SettingsElementStyleSelect,
  elementFontFamilySelect: SettingsFontFamilySelect,
  radioButton: SettingsRadioButton,
  toggleCheckbox: SettingsCheckbox,
  toggleInput: SettingsToggle,
  typeSelect: SettingsFieldSelect,
  colorInput: SettingsColorPicker,
  positionGroup: SettingsPositionGroup,
  fontStyleSelect: SettingsFontStyleSelect,
  sheetEntrySelect: SettingsSheetEntrySelect,
  settingsLabel: PanelLabel,
  dynamicParamsSelect: SettingsDynamicParamSelect,
  tableDimensionInput: SettingsTableDimensionInput,
}
